const dev = {
  // Callcenter Spring Boot backend
  API_ENDPOINT_URL: process.env.REACT_APP_API_URL || 'http://localhost:8080/api',
  // Socket.IO server (Node.js) - separate from Spring Boot backend
  SOCKET_IO_URL: process.env.REACT_APP_SOCKET_IO_URL || 'http://localhost:3010'
};

const prod = {
  // Callcenter Spring Boot backend
  API_ENDPOINT_URL: process.env.REACT_APP_API_URL || 'http://localhost:8080/api',
  // Socket.IO server (Node.js) - separate from Spring Boot backend
  SOCKET_IO_URL: process.env.REACT_APP_SOCKET_IO_URL || 'http://localhost:3010'
};

const test = {
  // Callcenter Spring Boot backend
  API_ENDPOINT_URL: process.env.REACT_APP_API_URL || 'http://localhost:8080/api',
  // Socket.IO server (Node.js) - separate from Spring Boot backend
  SOCKET_IO_URL: process.env.REACT_APP_SOCKET_IO_URL || 'http://localhost:3010'
};

const getEnv = () => {
	switch (process.env.NODE_ENV) {
		case 'development':
			return dev
		case 'production':
			return prod
		case 'test':
			return test
		default:
			break;
	}
}

export const env = getEnv()
